/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsCompanyEditCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanyExpiredCtrl', ["Company", "title", "userinfo", "$scope", "$state", "settings", function(Company, title, userinfo, $scope, $state, settings) {
  title.set('Subscription Expired');

  // Check that this site is still expired, they may have changed companies, or may have paid
  // in another location
  $scope.loading = Company.get(userinfo.activeCompany());
  $scope.loading.then(function(result) {
    if (result.subscriptionAllowed) {
      userinfo.companyDefaultReport().then(function(defaultReport) {
        $state.go(defaultReport);
      });
    }
    $scope.showPendingMessage = false;
    $scope.showExpiredMessage = false;
    if (moment().isBefore(result.created)) {
      $scope.showPendingMessage = true;
      $scope.migrationDate = moment(result.created).format(settings.dateFormats.mediumDate);
    } else {
      $scope.showExpiredMessage = true;
    }
  });
}]);
